var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-progress"},[_c('div',{staticClass:"upload-progress__bar"},[_c('div',{staticClass:"upload-progress__bar-value",style:({ width: _vm.value + '%' })})]),_c('div',{staticClass:"upload-progress__label"},[_vm._v(_vm._s(_vm.floor)+" %")])])
}
var staticRenderFns = []

export { render, staticRenderFns }